// API 接口配置
const API_CONFIG = {
  // API 基础地址
  BASE_URL: 'https://openapi.weoperations.com',
  
  // 接口路径
  ENDPOINTS: {
    // 统一订单详情接口
    COMMON_INTERFACE: '/SendTransaction/CommonInterface',
  },
  
  // WebSocket 配置
  WEBSOCKET: {
    URL: 'ws://127.0.0.1:2346'
  }
};

// 导出完整的接口地址
export default {
  // 统一订单详情接口
  getCommonInterfaceUrl: () => `${API_CONFIG.BASE_URL}${API_CONFIG.ENDPOINTS.COMMON_INTERFACE}`,
  
  // WebSocket 地址
  getWebSocketUrl: () => API_CONFIG.WEBSOCKET.URL,
  
  // 也可以直接导出配置对象供其他用途
  config: API_CONFIG
};

